module.exports = __webpack_public_path__ + "img/panelView_blackBg_2_1.ede4ff00.png";